import Vue from 'vue'
import VueRouter from 'vue-router'
// import firebase from 'firebase'
import firebase from '@/utils/firebase'


import Dashboard from '../components/Dashboard.vue'
import Login from '../components/Login'
import SignUp from '../components/SignUp'
import Widget from '../components/Widget'
import TestWidget from '../components/TestWidget'
import Integration from '../components/Integration'

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp,
  },
  {
    path: '/conversations',
    name: 'Conversations',
    component: Dashboard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ 'home'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/integration',
    name: 'Integration',
    component: Integration,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ 'home'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/widget/:company_id',
    name: 'Widget',
    component: Widget,
  },
  {
    path: '/test-widget/:company_id',
    name: 'Test Widget',
    component: TestWidget,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  console.log(store.state.user.loggedIn)
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth){
    firebase.auth().onAuthStateChanged(user => {
      if(user){
        next()
      }else{
        next({name:'Login'})
      }
    })
  } else {
    if (to.name == 'Login' || to.name == 'SignUp'){
      firebase.auth().onAuthStateChanged(user => {
        if(user){
          next({name:'Conversations'})
        }else{
          next()
        }
      })
    } else {
      next();
    }

  }
  console.log(store.state.user.loggedIn)
})




export default router
